import { useModal } from '@hrms/common/contexts/modal';
import { Button } from '@zeptonow/zui';
import React from 'react';
import { setUserPreferenceFromLocalStorage } from '../utils';

type UserPreferenceModalActionProps = { showCancelBtn: boolean };

const UserPreferenceModalAction: React.FC<UserPreferenceModalActionProps> = ({
  showCancelBtn,
}) => {
  const { hideModal, modalData } = useModal();
  const selectedTenant = modalData?.selectedTenant;
  const selectedSite = modalData?.selectedSite;

  const handleSave = () => {
    setUserPreferenceFromLocalStorage(modalData);
    window?.location?.reload();
  };

  return (
    <>
      {showCancelBtn ? (
        <Button
          variant="outlined"
          className={`!py-2 !px-4  w-full`}
          onClick={() => hideModal()}
        >
          Cancel
        </Button>
      ) : null}
      <Button
        variant="contained"
        className={`!py-2 !px-4  ml-3 w-full`}
        onClick={handleSave}
        disabled={!(selectedTenant?.id && selectedSite)}
      >
        Continue
      </Button>
    </>
  );
};

export default UserPreferenceModalAction;
